import { APP_PLATFORM_VERSION } from '@semios/app-platform-version'
import { PersistentStoreName } from 'stores/_utils/persistentStore/persistenceStoresCleanUpMap'
import { userDetailsStore } from 'stores/userDetailsStore/userDetailsStore'
import { ionicStore } from '../ionicStorage'

export const clearIonicStoreButKeepUserLanguage = async () => {
  const { language } = userDetailsStore.getState()

  await ionicStore.clear()

  await ionicStore.set(PersistentStoreName.USER_DETAILS_STORE, {
    language,
    storeVersion: APP_PLATFORM_VERSION,
    timestamp: Date.now(),
  })
}
